import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  'user' : {},
  'website' : {},
  'favicon' : '',
  'footer_pages': [],
  'fields'      : [],  
  'headerMenus': [],
  'paths': [],
  'miscellaneous': []
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserData: (state, action) => {
      // console.log('settig up', action);
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      for (let x in action.payload) {
        if (x in state) {
          state[x] = action.payload[x];
        }
      }
    },
    resetUserData: () => {
      return initialState;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setUserData, resetUserData } = userSlice.actions;

export default userSlice.reducer;
